import Icon from '../components/Icon.vue'

Icon.register({
  surprise: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM136 208C136 190.3 150.3 176 168 176S200 190.3 200 208 185.7 240 168 240 136 225.7 136 208zM248 416C212.7 416 184 387.3 184 352S212.7 288 248 288 312 316.7 312 352 283.3 416 248 416zM328 240C310.3 240 296 225.7 296 208S310.3 176 328 176 360 190.3 360 208 345.7 240 328 240z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/surprise.js
// module id = X+7J
// module chunks = 144